import {
  AdTypeOptionType,
  CampaignDashboardRecord,
  DashboardSummaryInfo
} from 'core/campaignDashboard/CampaignDashboard';
import { CampaignState } from 'core/rtbCampaign/RtbCampaign';
import client from './RestClient';
import { AxiosInstance } from 'axios';

export interface CampaignDashboardWebService {
  getSummaryInfo: (
    adType?: string,
    adTypeOptionType?: AdTypeOptionType
  ) => Promise<DashboardSummaryInfo[]>;

  getCampaignList: (
    day: number,
    adTypes?: string[],
    campaignStates?: CampaignState[],
    adTypeOptionTypes?: AdTypeOptionType[]
  ) => Promise<CampaignDashboardRecord[]>;
}

export class RestfulCampaignDashboardWebService implements CampaignDashboardWebService {
  restClient: AxiosInstance;

  constructor(restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async getSummaryInfo(
    adType?: string,
    adTypeOptionType?: AdTypeOptionType
  ): Promise<DashboardSummaryInfo[]> {
    let url = `/campaign-dashboard/summary/info`;
    const params: string[] = [];
    if (adType) {
      params.push(`adType=${adType}`);
    }
    if (adTypeOptionType) {
      params.push(`adTypeOptionType=${adTypeOptionType}`);
    }
    if (params.length > 0) {
      url = `${url}?${params.join('&')}`;
    }
    const response = await this.restClient.get(url);
    return response.data.records.map((summary: any) => ({
      ...summary,
      ctr: `${summary.impres > 0 ? ((summary.clicks * 100) / summary.impres).toFixed(2) : 0}%`
    }));
  }

  async getCampaignList(
    day: number,
    adTypes: string[] = [],
    campaignStates: CampaignState[] = [],
    adTypeOptionTypes: AdTypeOptionType[] = []
  ) {
    const params: string[] = [`day=${day}`];
    // Multi-select → repeated query params (index-aligned adTypes /
    // adTypeOptionTypes). ECOPD-5414.
    adTypes.forEach((adType) => params.push(`adTypes=${adType}`));
    adTypeOptionTypes.forEach((optionType) =>
      params.push(`adTypeOptionTypes=${optionType}`)
    );
    campaignStates.forEach((state) => params.push(`campaignStates=${state}`));
    // Back-compat: also send the legacy single params when exactly one value is
    // selected (trivial, keeps older BE happy during rollout).
    if (adTypes.length === 1) {
      params.push(`adType=${adTypes[0]}`);
    }
    if (adTypeOptionTypes.length === 1) {
      params.push(`adTypeOptionType=${adTypeOptionTypes[0]}`);
    }
    if (campaignStates.length === 1) {
      params.push(`campaignState=${campaignStates[0]}`);
    }
    const url = `/campaign-dashboard/campaignList?${params.join('&')}`;
    const response = await this.restClient.get(url);
    return response.data.records;
  }
}
